/** Settings API calls (typed). */

import { apiGet, apiPut, type PaginatedResponse } from "@/lib/api-client";
import type { ApiSetting } from "./settings.adapter";

export const settingsApi = {
  list: () => apiGet<PaginatedResponse<ApiSetting>>("/settings", { limit: 100 }),
  upsert: (key: string, value: unknown) =>
    apiPut<ApiSetting>(`/settings/${encodeURIComponent(key)}`, { value } as Record<string, unknown>),
};
